import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import $ from 'jquery';
import {create as cocoenCreate} from 'cocoen/dist/cocoen.esm.js';
import 'jquery.maskedinput/src/jquery.maskedinput.js';
import intlTelInput from 'intl-tel-input';
import 'magnific-popup';
import 'jquery-form-styler';

/* eslint-disable no-unused-vars */
/* FUNCTIONS ---------------------------------------------------------------------------------------------------- */
window.jQuery = window.$ = $;
function supportWebpAvif(A = []) {
	var t = [
			{ type: "webp", url: "data:image/webp;base64,UklGRhwAAABXRUJQVlA4TBAAAAAvAAAAEAfQpv5HmQMR0f8A" },
			{
				type: "avif",
				url:
					"data:image/avif;base64,AAAAHGZ0eXBtaWYxAAAAAG1pZjFhdmlmbWlhZgAAAPFtZXRhAAAAAAAAACFoZGxyAAAAAAAAAABwaWN0AAAAAAAAAAAAAAAAAAAAAA5waXRtAAAAAAABAAAAHmlsb2MAAAAABEAAAQABAAAAAAEVAAEAAAAeAAAAKGlpbmYAAAAAAAEAAAAaaW5mZQIAAAAAAQAAYXYwMUltYWdlAAAAAHBpcHJwAAAAUWlwY28AAAAUaXNwZQAAAAAAAAABAAAAAQAAABBwYXNwAAAAAQAAAAEAAAAVYXYxQ4EgAAAKBzgABpAQ0AIAAAAQcGl4aQAAAAADCAgIAAAAF2lwbWEAAAAAAAAAAQABBAECg4QAAAAmbWRhdAoHOAAGkBDQAjITFkAAAEgAAAB5TNw9UxdXU6F6oA == ",
			},
		].concat(A),
		e = {},
		o = [],
		a = document.querySelector("html");
	return (
		t.map((A) => {
			!(function (A) {
				let t = new Image();
				(t.src = A.url),
				(t.onerror = function () {
					var s = new Set(a.getAttribute("class") ? a.getAttribute("class").split(" ") : []);
					o.push(
						new Promise(function (t, o) {
							(e[A.type.toLowerCase()] = !1), t({ [A.type.toLowerCase()]: !1 });
						})
					),
					s.add("no-" + A.type.toLowerCase()),
					a.setAttribute("class", [...s].join(" "));
				}),
				(t.onload = function (t) {
					var s = new Set(a.getAttribute("class") ? a.getAttribute("class").split(" ") : []);
					o.push(
						new Promise(function (t, o) {
							(e[A.type.toLowerCase()] = !0), t({ [A.type.toLowerCase()]: !0 });
						})
					),
					s.add(A.type.toLowerCase()),
					a.setAttribute("class", [...s].join(" "));
				});
			})(A);
		}),
		Promise.all(o).then(function () {
			return e;
		})
	);
};
function getAppHeight() {
	document.documentElement.style.setProperty('--app-height', window.innerHeight + 'px');
	window.addEventListener('resize', function () {
		document.documentElement.style.setProperty('--app-height', window.innerHeight + 'px');
	});
};
function getScrollWidth() {
	let width = (window.innerWidth - document.documentElement.clientWidth) > 0 ? window.innerWidth - document.documentElement.clientWidth + 'px' : 6 + 'px';
	document.documentElement.style.setProperty('--scroll-width', width);
}
/* MAIN --------------------------------------------------------------------------------------------------------- */
// Функция для получения CSRF токена (если нужно)
export function getCookie(name) {
	let cookieValue = null;
	if (document.cookie && document.cookie !== '') {
		const cookies = document.cookie.split(';');
		for (let i = 0; i < cookies.length; i++) {
			const cookie = cookies[i].trim();
			if (cookie.substring(0, name.length + 1) === (name + '=')) {
				cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
				break;
			}
		}
	}
	return cookieValue;
}

function setCookie(name, value, options = {}) {
	options = {
		path: '/',
	};
	if (options.expires instanceof Date) {
		options.expires = options.expires.toUTCString();
	}
	let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
	for (let optionKey in options) {
		updatedCookie += "; " + optionKey;
		let optionValue = options[optionKey];
		if (optionValue !== true) {
			updatedCookie += "=" + optionValue;
		}
	}
	document.cookie = updatedCookie;
};
function deleteCookie(name) {
	setCookie(name, "", {
		'max-age': -1
	})
};

// Проверка заполненности обязательных полей с учетом условий чекбоксов
function validateStep(currentStep) {
	let isValid = true;
	const $currentStep = $('.visit-form .steps-list .step-item[data-step="' + currentStep + '"]');

	// Сначала убираем все подсветки ошибок
	$currentStep.find('.input-group').removeClass('error');
	$currentStep.find('.error-message').remove();

	// Проверяем, выбран ли чекбокс "Совпадает с адресом регистрации"
	const isSameAddress = $('input[name="RESIDENT"]').is(':checked');

	// Проверяем, есть ли видимые блоки с информацией о ребенке
	const hasChildInfo = $('.child-form__item:visible').length > 0;
	const hasPersonInfo = $('.person-form__item:visible').length > 0;

	$currentStep.find('input[required], select[required], textarea[required]').each(function () {
		if (!$(this).prop('disabled')) {
			const $input = $(this);
			const $inputGroup = $input.closest('.input-group');
			const inputName = $input.attr('name');

			// Пропускаем проверку полей адреса проживания, если выбран чекбокс
			if (isSameAddress && $input.closest('.address-info').length) {
				return true; // пропускаем проверку этого поля
			}

			// Пропускаем проверку полей ребенка, если нет информации о ребенке
			if (!hasChildInfo && $input.closest('.child-form__item').length) {
				return true;
			}

			// Пропускаем проверку полей ребенка, если нет информации о ребенке
			if (!hasPersonInfo && $input.closest('.person-form__item').length) {
				return true;
			}

			// Пропускаем проверку полей адреса ребенка, если соответствующие чекбоксы выбраны
			if (hasChildInfo) {
				const isChildRegSame = $('input[name="CHILD_REGISTER"]').is(':checked');
				const isChildAddressSame = $('input[name="CHILD_RESIDENT"]').is(':checked');

				if (isChildRegSame && $input.closest('.child-form__item .address-info').length) {
					return true;
				}

				if (isChildAddressSame && $input.closest('.child-form__item .address-info').length) {
					return true;
				}
			}

			if (!$input.val()) {
				isValid = false;
				$inputGroup.addClass('error');

				if (!$inputGroup.find('.error-message').length) {
					const errorText = $input.attr('data-error') || 'Это поле обязательно для заполнения';
					$inputGroup.append('<div class="error-message">' + errorText + '</div>');
				}
			}
		}
	});

	// Теперь отдельно проверяем чекбоксы с классом check-required
	const $checkRequiredBoxes = $currentStep.find('.check-required');
	if ($checkRequiredBoxes.length > 0) {
		// Проверяем, отмечен ли хотя бы один чекбокс
		const atLeastOneChecked = $checkRequiredBoxes.filter(':checked').length > 0;

		if (!atLeastOneChecked) {
			isValid = false;

			// Подсвечиваем все чекбоксы группы
			$checkRequiredBoxes.each(function () {
				const $input = $(this);
				const $inputGroup = $input.closest('.input-group');

				$inputGroup.addClass('error');

				if (!$inputGroup.find('.error-message').length) {
					// Можно использовать общее сообщение для всех или только для первого
					const errorText = $input.attr('data-error') || '&nbsp;Выберите хотя бы один вариант';
					$inputGroup.append('<div class="error-message">' + errorText + '</div>');
				}
			});
		}
	}

	return isValid;
}

// Обработчик изменения чекбоксов
function handleCheckboxChanges() {
	$('input[name="laddress_check"], input[name="child_reg"], input[name="child_address"]').on('change', function () {
		const currentStep = parseInt($('.visit-form .steps-list .step-item.active').attr('data-step'));
		validateStep(currentStep);
	});
}

// Функция для удаления ошибки с поля при его заполнении
function clearErrorOnInput() {
	$('.visit-form').on('input change', 'input[required], select[required], textarea[required]', function () {
		const $input = $(this);
		const $inputGroup = $input.closest('.input-group');

		if ($input.val()) {
			$inputGroup.removeClass('error');
			$inputGroup.find('.error-message').remove();
		}
	});
}

//Слайдер партнеров
let partnerSlider = null;

function initPartnersSlider() {
	const windowWidth = window.innerWidth;

	if (windowWidth < 576 && !partnerSlider) {
		$('.js-partners-slider').each(function (index, slider) {
			partnerSlider = new Swiper(slider, {
				direction: "horizontal",
				slideClass: "partner-logo-item",
				autoplay: {
					delay: 3600,
				},
				slidesPerView: 2,
				grid: {
					rows: 2,
					fill: "row",
				},
				modules: [Navigation, Pagination],
				spaceBetween: 10,
				navigation: {
					nextEl: $(slider).find('.nav-row .nav-btn.next-btn')[0],
					prevEl: $(slider).find('.nav-row .nav-btn.prev-btn')[0],
				},
				pagination: {
					el: $(slider).find('.nav-row .slider-pagination')[0],
					type: 'progressbar'
				},
			})
		})
	} else if (windowWidth >= 576 && partnerSlider) {
		partnerSlider.destroy(true, true);
		partnerSlider = null
	}
}
document.addEventListener("DOMContentLoaded", () => {
	supportWebpAvif();
	getAppHeight();
	getScrollWidth();
	handleCheckboxChanges();
	clearErrorOnInput();
	initPartnersSlider();


	window.addEventListener('resize', initPartnersSlider);
	/* main scripts */
	// header
	// hide header
	var scroll = 0;
	$(window).scroll(function () {
		if ($(window).scrollTop() > scroll && $(window).scrollTop() > 200) {
			$('.header').addClass('hide');
			// check phones block
			if ($('.header .js-phone-link').hasClass('active')) {
				$('.header .js-phone-link').removeClass('active');
				$('.header .js-phone-link').siblings('.phones-block').fadeOut(300);
			}
			// check menu
			if ($('.header .js-menu-btn').hasClass('active')) {
				$('.header .js-menu-btn').removeClass('active');
				$('.header #add-menu').fadeOut(300);
				if ($(window).width() < 992) {
					$('.header #main-menu').fadeOut(300);
				}
				$('.new-header #main-menu').fadeOut(300);
			}
			// check clinic menu
			if ($('.new-header .js-clinic-menu').hasClass('active')) {
				$('.new-header .js-clinic-menu').removeClass('active');
				$('.new-header .clinic-list').fadeOut(300);
			}
		} else {
			$('.header').removeClass('hide')
		}
		// show/hide scroll to top btn
		scroll = $(window).scrollTop();
		if ($(window).scrollTop() > 300) {
			$('#totop').fadeIn(300);
		}
		else {
			$('#totop').fadeOut(300);
		}
	});
	
	// clinic choose
	$(document).on('click', '.header .js-clinic-menu', function (e) {
		e.stopPropagation();
		if ($(window).width() < 992) {
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				$(this).siblings('.clinic-list').slideUp(300);
			}
			else {
				$(this).addClass('active');
				$(this).siblings('.clinic-list').slideDown(300);
			}
		}
	});
	// hamburger
	$(document).on('click', '.header .js-menu-btn', function () {
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			$('#' + $(this).attr('data-menu')).fadeOut(300);
			$('body').removeClass('menu-overflow');
		}
		else {
			$(this).addClass('active');
			$('#' + $(this).attr('data-menu')).fadeIn(300);
			$('body').addClass('menu-overflow');
		}
	});
	// phones block
	$(document).on('click', '.header .js-phone-link', function () {
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(this).siblings('.phones-block').fadeOut(300);
			if ($(document).width() <= 991) {
				$('body').removeClass('menu-overflow');
			}
		}
		else {
			$(this).addClass('active');
			$(this).siblings('.phones-block').fadeIn(300);
			if ($(document).width() <= 991) {
				$('body').addClass('menu-overflow');
			}
		}
	});

	// extra phone block
	$(document).on('click', '.header .js-extra-link', function (e) {
		if ($(window).width() >= 768) {
			e.preventDefault();
			if ($(this).hasClass('active')) {
				$(this).removeClass('active');
				$(this).siblings('.extra-block').fadeOut(300);
			}
			else {
				$(this).addClass('active');
				$(this).siblings('.extra-block').fadeIn(300);
			}
		}
	});
	// check open elements
	$(document).click(function (e) {
		var phonesContainer = $(".header .phones-block"),
			extraContainer = $(".header .extra-block"),
			addmenuContainer = $('.header .add-menu'),
			filterContainer = $('.js-custom-form .choose-list'),
			mainmenuContainer = $('.header .main-menu'),
			clinicContainer = $('.header .clinic-list');
		// check phones block
		if (phonesContainer.has(e.target).length === 0 && !e.target.classList.contains('js-phone-link')) {
			$('.header .js-phone-link').removeClass('active');
			phonesContainer.fadeOut(300);
			/*if($(document).width() <= 768 && !e.target.className.contains('.js-menu-btn')){
				$('body').removeClass('menu-overflow');
			}*/
		}
		// check add menu
		if (addmenuContainer.has(e.target).length === 0 && !e.target.classList.contains('js-menu-btn')) {
			$('.header .js-menu-btn').removeClass('active');
			addmenuContainer.fadeOut(300);
			if ($(document).width() <= 991 && !e.target.classList.contains('js-phone-link')) {
				$('body').removeClass('menu-overflow');
			}
		}
		// check filters
		if (filterContainer.has(e.target).length === 0 && (e.target.className != 'list-link js-list-link active' && e.target.className != 'list-link js-list-link added active')) {
			$('.js-custom-form .js-list-link.active').siblings('.choose-list').fadeOut(300);
			$('.js-custom-form .js-list-link.active').removeClass('active');
		}
		// check main menu
		if (mainmenuContainer.has(e.target).length === 0 && !e.target.classList.contains('js-menu-btn')) {
			if ($(window).width() < 992) {
				$('.header .js-menu-btn').removeClass('active');
				mainmenuContainer.fadeOut(300);
				if ($(document).width() <= 991 && !e.target.classList.contains('js-phone-link')) {
					$('body').removeClass('menu-overflow');
				}
			}
		}
		// clinic list
		if (clinicContainer.has(e.target).length === 0 && e.target.className != 'clinic-link js-clinic-menu active') {
			if ($(window).width() < 992) {
				$('.header .js-clinic-menu').removeClass('active');
				clinicContainer.slideUp(300);
			}
		}
		// check extra block
		if (extraContainer.has(e.target).length === 0 && e.target.className != 'extra-link js-extra-link active' && $(window).width() >= 768) {
			$('.header .js-extra-link').removeClass('active');
			extraContainer.fadeOut(300);
		}
	});

	// main-banner
	$('.js-main-slider').each(function (index, slider) {
		var mainSlider = new Swiper(slider, {
			slidesPerView: 1,
			loop: true,
			speed: 900,
			loopAdditionalSlides: 1,
			watchSlidesProgress: true,
			spaceBetween: 16,
			modules: [Navigation, Pagination],
			navigation: {
				nextEl: $(slider).find('.slider-navigation .nav-btn.next-btn')[0],
				prevEl: $(slider).find('.slider-navigation .nav-btn.prev-btn')[0],
			},
			pagination: {
				el: $(slider).find('.slider-pagination')[0],
				clickable: true
			},
			breakpoints: {
				577: {
					spaceBetween: 56
				}
			}
		});
	});

	// areas-section
	$(document).on('click', '.js-area-link', function () {
		var offsetValue = 150;
		$(this).parents('section').find('.area-tab').removeClass('active');
		$(this).parents('section').find('.area-tab[data-tab="' + $(this).attr('data-tab') + '"]').addClass('active');
		$(window).scrollTop($('#areas-list').offset().top - offsetValue);
		setCookie('position_cache', true);
		setCookie('current_tab', $(this).attr('data-tab'));
	});
	$(document).on('click', '.js-area-type', function () {
		$(this).parents('.tabs-column').find('.js-area-type').removeClass('active');
		$(this).addClass('active');
		// change image
		$(this).parents('.tabs-column').siblings('.image-column').find('.type-image').removeClass('active');
		$(this).parents('.tabs-column').siblings('.image-column').find('.type-image[data-type="' + $(this).attr('data-type') + '"]').addClass('active');
		// change tab
		$(this).parents('.tabs-column').siblings('.content-column').find('.content-type').removeClass('active');
		$(this).parents('.tabs-column').siblings('.content-column').find('.content-type[data-type="' + $(this).attr('data-type') + '"]').addClass('active');
		setCookie('current_subtab', $(this).attr('data-type'));
	});

	// doctors section
	// custom filter (available for all blocks)
	// open lists
	$(document).on('click', '.js-custom-form .js-list-link', function () {
		var curForm = $(this).parents('section').find('.js-custom-form');
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(this).siblings('.choose-list').fadeOut(300);
		}
		else {
			// close opened
			curForm.find('.js-list-link.active').siblings('.choose-list').fadeOut(300);
			curForm.find('.js-list-link.active').removeClass('active');
			// open new
			$(this).addClass('active');
			$(this).siblings('.choose-list').fadeIn(300);
		}
	});
	// change filter
	$(document).on('change', '.js-custom-form', function () {
		var curForm = $(this),
			curSection = $(this).siblings('.js-isotope-block');
		// check clinics
		curForm.find('.clinic-list').siblings('.js-list-link').removeClass('added').find('span').remove();
		if (curForm.find('.clinic-list input:checked').length > 0) {
			curForm.find('.clinic-list input:checked').each(function (index, el) {
				curForm.find('.clinic-list').siblings('.js-list-link').append('<span style="' + $(el).siblings('.label').attr('style') + '">' + $(el).siblings('.label').text() + '</span>');
			});
			curForm.find('.clinic-list').siblings('.js-list-link').addClass('added');
		}
		// check other (radio)
		curForm.find('.radio-list').siblings('.js-list-link').removeClass('added').find('span').remove();
		curForm.find('.radio-list').each(function (index, list) {
			if ($(list).find('input:checked').length > 0) {
				$(list).find('input:checked').each(function (index, el) {
					$(list).siblings('.js-list-link').append('<span>' + $(el).siblings('.label').text() + '</span>');
				});
				$(list).siblings('.js-list-link').addClass('added');
			}
		});
		// close radio list
		curForm.find('.radio-list').fadeOut(300).siblings('.js-list-link').removeClass('active');
		// check other (check)
		curForm.find('.check-list').siblings('.js-list-link').removeClass('added').find('span').remove();
		curForm.find('.check-list').each(function (index, list) {
			if ($(list).find('input:checked').length > 0) {
				$(list).find('input:checked').each(function (index, el) {
					$(list).siblings('.js-list-link').append('<span>' + $(el).siblings('.label').text() + '</span>');
				});
				$(list).siblings('.js-list-link').addClass('added');
			}
		});
		// filtering
		$(curSection).find('.js-isotope-item').removeClass('show');
		// TODO some ajax and get new content
		// TODO after success - set new html and add 'show' class to items
		setTimeout(function () {
			// here ajax but without timeout 300 ⇑⇑⇑
			// and inside success callback add this ⇓⇓⇓
			setTimeout(function () {
				$(curSection).find('.js-isotope-item').addClass('show');
			}, 100);
			// if result is empty
			// add <div class="js-isotope-item empty-item"><p>К сожалению, ничего не найдено</p></div>
			// and hide btns-row with more btn
		}, 300);
	});
	// reset filter
	$(document).on('click', '.js-custom-form .js-reset-link', function () {
		var curForm = $(this).parents('section').find('.js-custom-form');
		curForm.find('.clinic-list input').prop('checked', false);
		curForm.find('.radio-list input').prop('checked', false);
		curForm.find('.check-list input').prop('checked', false);
		curForm.trigger('change');
		curForm.find('.choose-list').fadeOut(300).siblings('.js-list-link').removeClass('active');
	});
	$(document).on('click', '.js-custom-form .js-submit-link', function () {
		$(this).parents('form').submit();
	});

	// about-section
	// about slider
	$('.js-about-slider').each(function (index, slider) {
		var aboutSlider = new Swiper(slider, {
			slidesPerView: 1,
			direction: 'vertical',
			loop: true,
			speed: 900,
			autoplay: {
				delay: 3000
			},
			spaceBetween: 0,
		});
	});

	// find section
	// main tab
	$(document).on('click', '.js-tab-link', function () {
		$(this).parents('.tabs-links').find('.js-tab-link').removeClass('active');
		$(this).parents('section').find('.tab-item').removeClass('active');
		$(this).addClass('active');
		$(this).parents('section').find('.tab-item[data-tab="' + $(this).attr('data-tab') + '"]').addClass('active');
	});
	// method tab
	$(document).on('click', '.js-method-link', function () {
		$(this).parents('.method-links').find('.js-method-link').removeClass('active');
		$(this).parents('.descr-side').find('.method-tab').removeClass('active');
		$(this).addClass('active');
		$(this).parents('.descr-side').find('.method-tab[data-type="' + $(this).attr('data-type') + '"]').addClass('active');
	});

	// form section
	// main tabs
	$(document).on('click', '.js-form-type', function () {
		$(this).parents('.form-types').find('.js-form-type').removeClass('active');
		$(this).parents('.form-types').siblings('.form-tabs').find('.tab-item').removeClass('active');
		$(this).addClass('active');
		$(this).parents('.form-types').siblings('.form-tabs').find('.tab-item[data-tab="' + $(this).attr('data-tab') + '"]').addClass('active');
	});
	// check form
	$(document).on('change', '.js-check-form', function () {
		if ($(this).find('input[name="check_two"]').length > 0) {
			if ($(this).find('input[name="check"]').prop('checked') && $(this).find('input[name="check_two"]').prop('checked')) {
				$(this).find('button[type="submit"]').prop('disabled', false);
			} else {
				$(this).find('button[type="submit"]').prop('disabled', true);
			}
		} else {
			if ($(this).find('input[name="check"]').prop('checked')) {
				$(this).find('button[type="submit"]').prop('disabled', false);
			} else {
				$(this).find('button[type="submit"]').prop('disabled', true);
			}
		}

		// Теперь отдельно проверяем чекбоксы с классом check-required
		let $checkRequiredBoxes = $(this).find('input[name="form_checkbox_check[]');
		if ($checkRequiredBoxes.length > 0) {
			let checkedCount = $checkRequiredBoxes.filter(':checked').length;
			let totalCount = $checkRequiredBoxes.length;

			// Разрешаем отправку только если ВСЕ отмечены
			let canSubmit = (checkedCount === totalCount);
			if (canSubmit) {
				$(this).find('button[type="submit"]').prop('disabled', false);
			}
		}
	});

	// news section
	// custom filter (available for all blocks)
	// reset inputs
	$(document).on('change', '.js-filter-form input[type="checkbox"]', function () {
		if ($(this).prop('checked')) {
			$(this).parents('form').find('input[type="checkbox"]').prop('checked', false);
			$(this).prop('checked', true);
		}
	})
	// form change
	$(document).on('change', '.js-filter-form', function () {
		//console.log('test');
		var curSection = $(this).siblings('.js-isotope-block');
		$(curSection).find('.js-isotope-item').removeClass('show');
		// TODO some ajax and get new content
		// TODO after success - set new html and add 'show' class to items
		setTimeout(function () {
			// here ajax but without timeout 300 ⇑⇑⇑
			// and inside success callback add this ⇓⇓⇓
			setTimeout(function () {
				$(curSection).find('.js-isotope-item').addClass('show');
			}, 100);
			// if result is empty
			// add <div class="js-isotope-item empty-item"><p>К сожалению, ничего не найдено</p></div>
			// and hide btns-row with more btn
		}, 300);
	});

	// for patients
	$(document).on('click', '.js-faq-link', function () {
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(this).siblings('.item-descr').slideUp(300);
		}
		else {
			$(this).addClass('active');
			$(this).siblings('.item-descr').slideDown(300);
		}
	});

	// information legal
	$(document).on('click', '.js-steps-link', function () {
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(this).siblings('.steps-descr').slideUp(300);
		}
		else {
			$(this).addClass('active');
			$(this).siblings('.steps-descr').slideDown(300);
		}
	});

	// service single
	$(document).on('click', '.js-info-title', function () {
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(this).siblings('.item-descr').slideUp(300);
		}
		else {
			$(this).addClass('active');
			$(this).siblings('.item-descr').slideDown(300);
		}
	});
	$(document).on('click', '.js-bafter-link', function () {
		$(this).parents('.tab-links').find('.js-bafter-link').removeClass('active');
		$(this).addClass('active');
		$(this).parents('.modal-content').find('.tab-item').removeClass('active');
		$(this).parents('.modal-content').find('.tab-item[data-tab="' + $(this).attr('data-tab') + '"]').addClass('active');
		// before after slider
		if ($(this).parents('.modal-content').find('.tab-item[data-tab="' + $(this).attr('data-tab') + '"]').find('.js-before-after').length > 0) {
			console.log('init link');
			var updSlider = cocoenCreate($(this).parents('.modal-content').find('.tab-item[data-tab="' + $(this).attr('data-tab') + '"]').find('.js-before-after')[0]),
				sl_styles = document.createElement('style');
			sl_styles.innerHTML = '#drag:before {\n' +
				'	border: none;\n' +
				'	content: \'\\e800\';\n' +
				'	height: 30px;\n' +
				'	left: calc(50% - 15px);\n' +
				'	position: absolute;\n' +
				'	top: calc(50% - 30px);\n' +
				'	width: 30px;\n' +
				'	transform: translate3d(-50%, -50%, 0) scale(-1, 1);\n' +
				'	color: #fff;\n' +
				'	display: inline-block;\n' +
				'	margin: 0;\n' +
				'	padding: 0;\n' +
				'	font-family: Fontello;\n' +
				'	font-style: normal;\n' +
				'	font-weight: normal;\n' +
				'	speak: never;\n' +
				'	text-decoration: inherit;\n' +
				'	text-align: center;\n' +
				'	font-variant: normal;\n' +
				'	text-transform: none;\n' +
				'	pointer-events: none;\n' +
				'	display: flex;\n' +
				'	align-items: center;\n' +
				'	justify-content: center;\n' +
				'}   #drag:after {\n' +
				'	border: none;\n' +
				'	content: \'\\e800\';\n' +
				'	height: 30px;\n' +
				'	left: calc(50% + 15px);\n' +
				'	position: absolute;\n' +
				'	top: calc(50% - 30px);\n' +
				'	width: 30px;\n' +
				'	transform: translate3d(-50%, -50%, 0);\n' +
				'	color: #fff;\n' +
				'	display: inline-block;\n' +
				'	margin: 0;\n' +
				'	padding: 0;\n' +
				'	font-family: Fontello;\n' +
				'	font-style: normal;\n' +
				'	font-weight: normal;\n' +
				'	speak: never;\n' +
				'	text-decoration: inherit;\n' +
				'	text-align: center;\n' +
				'	font-variant: normal;\n' +
				'	text-transform: none;\n' +
				'	pointer-events: none;\n' +
				'	display: flex;\n' +
				'	align-items: center;\n' +
				'	justify-content: center;\n' +
				'} div#drag {\n' +
				'	cursor: default;\n' +
				'}';
			updSlider.shadowRoot.appendChild(sl_styles);
		}
	});
	// black section slider
	$('.js-black-slider').each(function (index, slider) {
		var blackSlider = new Swiper(slider, {
			slidesPerView: 'auto',
			loop: false,
			watchSlidesProgress: true,
			speed: 800,
			spaceBetween: 24,
			modules: [Navigation, Pagination],
			navigation: {
				nextEl: $(slider).find('.nav-row .nav-btn.next-btn')[0],
				prevEl: $(slider).find('.nav-row .nav-btn.prev-btn')[0],
			},
			pagination: {
				el: $(slider).find('.nav-row .slider-pagination')[0],
				type: 'progressbar'
			},
			on: {
				init: function (e) {
					$(slider).find('.swiper-slide.swiper-slide-fully-visible').find('video').attr('controls', '');
				},
				slideChangeTransitionEnd: function (e) {
					$(slider).find('.swiper-slide.swiper-slide-fully-visible').find('video').attr('controls', '');
				}
			}
		});
	});

	// doctors single
	// education tabs
	$(document).on('click', '.js-edu-tab', function () {
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			$(this).parents('.education-section').find('.doc-tabs .tabs-item').removeClass('active');
			$(this).parents('.education-section').find('.doc-tabs .tabs-item[data-tab="0"]').addClass('active');
		}
		else {
			$(this).parents('ul').find('.js-edu-tab').removeClass('active');
			$(this).addClass('active');
			$(this).parents('.education-section').find('.doc-tabs .tabs-item').removeClass('active');
			$(this).parents('.education-section').find('.doc-tabs .tabs-item[data-tab="' + $(this).attr('data-tab') + '"]').addClass('active');
		}
	});
	// articles slider
	$('.js-article-slider').each(function (index, slider) {
		var articlesSlider = new Swiper(slider, {
			slidesPerView: 'auto',
			loop: false,
			watchSlidesProgress: true,
			speed: 800,
			spaceBetween: 24,
			modules: [Navigation, Pagination],
			navigation: {
				nextEl: $(slider).find('.nav-row .nav-btn.next-btn')[0],
				prevEl: $(slider).find('.nav-row .nav-btn.prev-btn')[0],
			},
			pagination: {
				el: $(slider).find('.nav-row .slider-pagination')[0],
				type: 'progressbar'
			}
		});
	});

	// group page
	$('.group-main').each(function (index, section) {
		var thumbsSlider = new Swiper($(section).find('.js-group-thumbs')[0], {
			slidesPerView: 'auto',
			watchSlidesProgress: true,
			allowTouchMove: true,
			speed: 800,
			spaceBetween: 40,
			breakpoints: {
				1520: {
					allowTouchMove: false
				},
				1201: {
					spaceBetween: 60
				}
			}
		});
		var mainSlider = new Swiper($(section).find('.js-group-slider')[0], {
			slidesPerView: 1,
			watchSlidesProgress: true,
			speed: 800,
			spaceBetween: 20,
			/*
			autoplay: {
				delay: 3000
			},
			thumbs: {
				swiper: $(section).find('.js-group-thumbs')[0]
			},
			 */
			on: {
				init: function (e) {
					$(section).find('.js-group-slider').find('.swiper-slide.swiper-slide-fully-visible').find('video').attr('controls', '');
				},
				slideChangeTransitionEnd: function (e) {
					$(section).find('.js-group-slider').find('.swiper-slide.swiper-slide-fully-visible').find('video').attr('controls', '');
				}
			},
			modules: [Navigation, Pagination],
			navigation: {
				nextEl: $(section).find('.slider-navigation').find('.nav-btn.next-btn')[0],
				prevEl: $(section).find('.slider-navigation').find('.nav-btn.prev-btn')[0],
			},
		});
	});
	$('.persons-section').each(function (index, section) {
		$(section).find('.tab-item').each(function (index, tab) {
			var imageSlider = new Swiper($(tab).find('.js-persons-slider')[0], {
				slidesPerView: 'auto',
				allowTouchMove: true,
				centeredSlides: true,
				slideToClickedSlide: true,
				initialSlide: 1,
				speed: 800,
				spaceBetween: 0,
				breakpoints: {
					769: {
						allowTouchMove: false,
					}
				}
			});
			var descrSlider = new Swiper($(tab).find('.js-persons-descr-slider')[0], {
				slidesPerView: 1,
				watchSlidesProgress: true,
				loop: false,
				initialSlide: 1,
				speed: 800,
				spaceBetween: 0,
				modules: [Navigation, Pagination],
				navigation: {
					nextEl: $(tab).find('.tab-item__left-side .nav-row').find('.slider-navigation .nav-btn.next-btn')[0],
					prevEl: $(tab).find('.tab-item__left-side .nav-row').find('.slider-navigation .nav-btn.prev-btn')[0],
				},
				on: {
					slideChange: function (e) {
						imageSlider.slideTo(e.realIndex);
					}
				},
				pagination: {
					el: $(tab).find('.tab-item__left-side .nav-row .slider-pagination')[0],
					type: "fraction",
				}
			});
			imageSlider.on('slideChange', function (e) {
				descrSlider.slideTo(e.realIndex);
			});
		})
	});
	// history section
	$('.js-years-slider').each(function (index, slider) {
		var yearsSlider = new Swiper(slider, {
			slidesPerView: 'auto',
			direction: 'horizontal',
			centeredSlides: true,
			slideToClickedSlide: true,
			loop: false,
			watchSlidesProgress: true,
			speed: 800,
			spaceBetween: 32,
			modules: [Navigation, Pagination],
			navigation: {
				nextEl: $(slider).parent().find('.slider-navigation .nav-btn.next-btn')[0],
				prevEl: $(slider).parent().find('.slider-navigation .nav-btn.prev-btn')[0],
			},
			on: {
				slideChange: function (e) {
					$(slider).parents('.history-section__content').find('.history-tab').removeClass('active');
					$(slider).parents('.history-section__content').find('.history-tab[data-time="' + $(e.slides[e.activeIndex]).attr('data-time') + '"]').addClass('active');
				}
			},
			breakpoints: {
				1336: {
					direction: 'vertical',
				}
			}
		});
	});
	$('.js-history-slider').each(function (index, slider) {
		var historySlider = new Swiper(slider, {
			slidesPerView: 'auto',
			loop: false,
			watchSlidesProgress: true,
			speed: 800,
			spaceBetween: 24,
			modules: [Navigation, Pagination],
			navigation: {
				nextEl: $(slider).parents('.history-tab').find('.nav-row .nav-btn.next-btn')[0],
				prevEl: $(slider).parents('.history-tab').find('.nav-row .nav-btn.prev-btn')[0],
			},
			pagination: {
				el: $(slider).parents('.history-tab').find('.nav-row .slider-pagination')[0],
				type: "fraction",
			}
		});
	});
	// trust slider
	$('.js-trust-slider').each(function (index, slider) {
		var trustSlider = new Swiper(slider, {
			slidesPerView: 1.6,
			centeredSlides: true,
			loop: true,
			watchSlidesProgress: true,
			speed: 800,
			spaceBetween: 60,
			modules: [Navigation, Pagination],
			navigation: {
				nextEl: $(slider).find('.slider-navigation .nav-btn.next-btn')[0],
				prevEl: $(slider).find('.slider-navigation .nav-btn.prev-btn')[0],
			},
			on: {
				init: function (e) {
					$(slider).find('.swiper-slide.swiper-slide-active').find('.slide-descr').slideDown(300);
				},
				slideChangeTransitionStart: function (e) {
					$(slider).find('.swiper-slide').find('.slide-descr').slideUp(0);
				},
				slideChangeTransitionEnd: function (e) {
					$(slider).find('.swiper-slide.swiper-slide-active').find('.slide-descr').slideDown(300);
				}
			},
			breakpoints: {
				961: {
					slidesPerView: 3
				},
				641: {
					slidesPerView: 2.2
				},
				576: {
					slidesPerView: 1.8
				}
			}

		});
	});
	// map slider
	$('.js-map-slider').each(function (index, slider) {
		var mapSlider = new Swiper(slider, {
			slidesPerView: 'auto',
			loop: false,
			speed: 900,
			spaceBetween: 0,
			modules: [Navigation, Pagination],
			navigation: {
				nextEl: $(slider).find('.slider-navigation .nav-btn.next-btn')[0],
				prevEl: $(slider).find('.slider-navigation .nav-btn.prev-btn')[0],
			}
		});
	});

	// review slider
	$('.js-review-slider').each(function (index, slider) {
		var reviewSlider = new Swiper(slider, {
			slidesPerView: 1,
			loop: true,
			speed: 900,
			loopAdditionalSlides: 1,
			watchSlidesProgress: true,
			spaceBetween: 16,
			modules: [Navigation, Pagination],
			navigation: {
				nextEl: $(slider).find('.slider-navigation .nav-btn.next-btn')[0],
				prevEl: $(slider).find('.slider-navigation .nav-btn.prev-btn')[0],
			}
		});
	});

	// diagnostics page
	$('.js-inter-slider').each(function (index, slider) {
		var interSlider = new Swiper(slider, {
			slidesPerView: 'auto',
			loop: false,
			watchSlidesProgress: true,
			speed: 800,
			spaceBetween: 12,
			modules: [Navigation, Pagination],
			navigation: {
				nextEl: $(slider).find('.nav-row .nav-btn.next-btn')[0],
				prevEl: $(slider).find('.nav-row .nav-btn.prev-btn')[0],
			},
			pagination: {
				el: $(slider).find('.nav-row .slider-pagination')[0],
				type: 'progressbar'
			},
			breakpoints: {
				576: {
					spaceBetween: 25
				}
			}
		});
	});
	$(document).on('click', '.js-video-start', function () {
		if ($(this).hasClass('play')) {
			$(this).removeClass('play');
			$(this).siblings('video').get(0).pause();
		}
		else {
			$(this).siblings('video').get(0).play();
			$(this).addClass('play');
		}
	});

	// new index
	// new slider
	$('.js-common-slider').each(function (index, slider) {
		var commonSlider = new Swiper(slider, {
			slidesPerView: 1,
			loop: false,
			watchSlidesProgress: true,
			speed: 800,
			spaceBetween: 12,
			autoplay: {
				delay: 3600,
			},
			modules: [Navigation, Pagination, Autoplay],
			navigation: {
				nextEl: $(slider).find('.nav-row .nav-btn.next-btn')[0],
				prevEl: $(slider).find('.nav-row .nav-btn.prev-btn')[0],
			},
			pagination: {
				el: $(slider).find('.nav-row .slider-pagination')[0],
				type: 'progressbar',
			},
			breakpoints: {
				576: {
					spaceBetween: 25
				}
			}
		});
	});
	// clinics views
	$(document).on('click', '.js-view-tab', function () {
		$(this).parents('.view-type').find('.js-view-tab').removeClass('active');
		$(this).addClass('active');
		$(this).parents('.main-clinics').find('.tab-item').removeClass('active');
		$(this).parents('.main-clinics').find('.tab-item[data-tab="' + $(this).attr('data-tab') + '"]').addClass('active');
	});
	// articles slider
	$('.js-articles-slider').each(function (index, slider) {
		var articlesSlider = new Swiper(slider, {
			slidesPerView: 1,
			loop: false,
			watchSlidesProgress: true,
			speed: 800,
			spaceBetween: 16,
			modules: [Navigation, Pagination],
			navigation: {
				nextEl: $(slider).parent().find('.nav-btn.next-btn')[0],
				prevEl: $(slider).parent().find('.nav-btn.prev-btn')[0],
			},
			pagination: {
				el: $(slider).parent().find('.slider-pagination')[0],
				clickable: true
			},
			breakpoints: {
				769: {
					slidesPerView: 3,
				},
				641: {
					spaceBetween: 24,
				},
				476: {
					slidesPerView: 2
				}
			}
		});
	});

	// new news page
	$(document).on('click', '.js-news-type', function () {
		$(this).parent().find('.js-news-type').removeClass('active');
		// TODO some ajax
		$(this).addClass('active');
	});


	// hospitals
	// main slider
	$('.hospitals-main').each(function (index, section) {
		var thumbsSlider = new Swiper('#hospital-thumbs', {
			slidesPerView: 'auto',
			slidesPerGroup: 1,
			speed: 800,
			spaceBetween: 16,
			breakpoints: {
				960: {
					spaceBetween: 24,
					slidesPerView: 3,
					slidesPerGroup: 3
				},
				768: {
					slidesPerView: 2,
					slidesPerGroup: 2,
				}

			}
		});
		var mainSlider = new Swiper('#hospital-slider', {
			slidesPerView: 1,
			speed: 800,
			spaceBetween: 0,
			effect: "fade",
			thumbs: {
				swiper: '#hospital-thumbs'
			},
			modules: [Navigation, Pagination],
			navigation: {
				nextEl: $('#hospital-thumbs').find('.nav-row .nav-btn.next-btn')[0],
				prevEl: $('#hospital-thumbs').find('.nav-row .nav-btn.prev-btn')[0],
			},
			pagination: {
				el: $('#hospital-thumbs').find('.nav-row .slider-pagination')[0],
				type: 'progressbar'
			}
		});
	});

	// scroll link
	if ($('.js-scroll-link').length > 0) {
		var url = window.location.pathname,
			url_hash = window.location.hash,
			headerHeight = $('.header').outerHeight(),
			offsetValue = 50;
		$(document).on('click', '.js-scroll-link', function (e) {
			window.history.replaceState(null, null, url + '#' + $(this).attr('data-ancor'));
			if ($('#' + $(this).attr('data-ancor')).length > 0) {
				$(window).scrollTop($('#' + $(this).attr('data-ancor')).offset().top - offsetValue);
			}
		});
		// if isset hash
		setTimeout(function () {
			if (url_hash != '' && typeof url_hash !== "undefined") {
				if ($(url_hash).length > 0) {
					$(window).scrollTop($('' + url_hash + '').offset().top - offsetValue);
				}
			}
		}, 500);
	}
	$(document).on('click', '.js-doctor-backcall', function () {
		if ($('#backcall-section').length > 0) {
			$('#backcall-section').find('.js-form-type[data-tab="2"]').click();
		}
	});
	// custom select
	setTimeout(function () {
		$('.js-custom-select').each(function (index, select) {
			if ($(select).attr('required')) {
				$(select).addClass('required');
			}
			$(select).styler({
				selectSmartPositioning: false
			});
		})
	}, 100);

	// scroll to top btn
	$(document).on('click', '.js-top-scroll', function () {
		$(window).scrollTop(0);
	});
	// file group function
	$(document).on('change', 'input[type="file"]', function () {
		$(this).siblings('.file-label').addClass('attached').find('span').text($(this)[0].files[0].name);
	});
	// phone mask
	/*
	$.fn.setCursorPosition = function(pos) {
		if ($(this).get(0).setSelectionRange) {
			$(this).get(0).setSelectionRange(pos, pos);
		} else if ($(this).get(0).createTextRange) {
			var range = $(this).get(0).createTextRange();
			range.collapse(true);
			range.moveEnd('character', pos);
			range.moveStart('character', pos);
			range.select();
		}
	};
	$('.js-phone-input').click(function (){
		$(this).setCursorPosition(3);
	}).mask("+7 999 999-99-99");
	// sn number
	$('.js-sn-input').click(function (){
		$(this).setCursorPosition(0);
	}).mask("999-999-999 99");
	 */
	$('.js-phone-input').each(function (index, input) {
		let itl = intlTelInput(input, {
			initialCountry: "ru",
			placeholderNumberType: "MOBILE",
			countrySearch: false,
			separateDialCode: true,
			nationalMode: true,
			strictMode: true,
			autoPlaceholder: "aggressive",
			i18n: {
				// Aria label for the selected country element
				selectedCountryAriaLabel: "Выбрано",
				// Screen reader text for when no country is selected
				noCountrySelected: "Не выбрано",
				// Aria label for the country list element
				countryListAriaLabel: "Список",
				// Placeholder for the search input in the dropdown
				searchPlaceholder: "Поиск",
				// Screen reader text for when the search produces no results
				zeroSearchResults: "Не найдено",
				// Screen reader text for when the search produces 1 result
				oneSearchResult: "1 результат",
				// Screen reader text for when the search produces multiple results
				multipleSearchResults: "${count} результатов",
			},
			//hiddenInput: () => ({ phone: "full_phone", country: "country_code" }),
			loadUtils: () => import("../../../../../assets/js/vendors/utils.js"), // /local/templates/olymp/assets/js + .min
		});

		$(document).on('input', input, function (e) {
			let phone = $(input).parents('.input-group').find('.hidden_phone');
			$(phone).attr('value', itl.getNumber());
		});
	});

	// new forms functions
	// add content
	$('.visit-form .js-part-input').on('change', function () {
		if ($(this).prop('checked')) {
			$(this).parents('.form-part').find('.part-content').slideDown(300);
			$(this).parents('.form-part').find('.part-content').find('input,select').prop('disabled', false);
			$(this).parents('.input-group').find('.error-message').remove();
			$(this).parents('.input-group').removeClass('error');
		}
		else {
			$(this).parents('.form-part').find('.part-content').slideUp(300);
			$(this).parents('.form-part').find('.part-content').find('input,select').prop('disabled', true);
		}
	});
	// add content inside
	$('.visit-form .part-content input[type="radio"]').on('change', function () {
		$(this).parents('.part-content').find('.part-result').slideUp(300);
		$(this).parents('.part-content').find('.part-result[data-type="' + $(this).attr('data-type') + '"]').slideDown(300);
	});
	// add input btn
	$(document).on('click', '.visit-form .js-add-input', function () {
		var index = parseInt($(this).attr('data-index')) + 1;
		var block = $(this).closest('.item-section').find('.step-form .input-row:eq(0)').clone(true, true);
		block.find('input').each(function () {
			$(this).attr({
				'name': $(this).attr('name') + '_' + index
			});
		});
		$(this).closest('.item-section').find('.step-form .btn-group').before(block);
		$(this).attr('data-index', index);
	});
	// remove input btn
	$(document).on('click', '.visit-form .js-delete-input', function () {
		$(this).parent().remove();
	});

	// simple modal
	$('.js-modal-link').magnificPopup({
		type: 'inline',
		fixedContentPos: true,
		fixedBgPos: true,
		showCloseBtn: false,
		tClose: 'Закрыть',
		mainClass: 'mfp-zoom-in',
		callbacks: {
			open: function (e) {
				$('body').addClass('overflow');
				// check before after slide inside and init
				var magnificPopup = $.magnificPopup.instance;
				if ($(magnificPopup.currItem.src).hasClass('result-modal')) {
					var updSlider = cocoenCreate($(magnificPopup.currItem.src).find('.tab-item.active .js-before-after')[0]),
						sl_styles = document.createElement('style');
					sl_styles.innerHTML = '#drag:before {\n' +
						'	border: none;\n' +
						'	content: \'\\e800\';\n' +
						'	height: 30px;\n' +
						'	left: calc(50% - 15px);\n' +
						'	position: absolute;\n' +
						'	top: calc(50% - 30px);\n' +
						'	width: 30px;\n' +
						'	transform: translate3d(-50%, -50%, 0) scale(-1, 1);\n' +
						'	color: #fff;\n' +
						'	display: inline-block;\n' +
						'	margin: 0;\n' +
						'	padding: 0;\n' +
						'	font-family: Fontello;\n' +
						'	font-style: normal;\n' +
						'	font-weight: normal;\n' +
						'	speak: never;\n' +
						'	text-decoration: inherit;\n' +
						'	text-align: center;\n' +
						'	font-variant: normal;\n' +
						'	text-transform: none;\n' +
						'	pointer-events: none;\n' +
						'	display: flex;\n' +
						'	align-items: center;\n' +
						'	justify-content: center;\n' +
						'}   #drag:after {\n' +
						'	border: none;\n' +
						'	content: \'\\e800\';\n' +
						'	height: 30px;\n' +
						'	left: calc(50% + 15px);\n' +
						'	position: absolute;\n' +
						'	top: calc(50% - 30px);\n' +
						'	width: 30px;\n' +
						'	transform: translate3d(-50%, -50%, 0);\n' +
						'	color: #fff;\n' +
						'	display: inline-block;\n' +
						'	margin: 0;\n' +
						'	padding: 0;\n' +
						'	font-family: Fontello;\n' +
						'	font-style: normal;\n' +
						'	font-weight: normal;\n' +
						'	speak: never;\n' +
						'	text-decoration: inherit;\n' +
						'	text-align: center;\n' +
						'	font-variant: normal;\n' +
						'	text-transform: none;\n' +
						'	pointer-events: none;\n' +
						'	display: flex;\n' +
						'	align-items: center;\n' +
						'	justify-content: center;\n' +
						'} div#drag {\n' +
						'	cursor: default;\n' +
						'}';
					updSlider.shadowRoot.appendChild(sl_styles);
				}
			},
			close: function (e) {
				$('body').removeClass('overflow');
				// check before after slide inside and destroy
				var magnificPopup = $.magnificPopup.instance;
				if ($(magnificPopup.currItem.src).hasClass('result-modal')) {
					$(magnificPopup.currItem.src).find('cocoen-component').each(function (index, element) {
						var imageBefore = $(element).find('img.before-image')[0].outerHTML,
							imageAfter = $(element).find('img.after-image')[0].outerHTML;
						$(element).parent().append('<div class="js-before-after cocoen">' + imageBefore + imageAfter + '</div>');
						$(element).remove();
					});
				}
			}
		}
	});
	// image modal
	$('.js-image-link').magnificPopup({
		type: 'image',
		mainClass: 'mfp-zoom-in',
		fixedContentPos: true,
		removalDelay: 160,
		preloader: false,
		tClose: 'Закрыть',
		image: {
			tError: 'Невозможно загрузить :('
		},
		callbacks: {
			open: function () {
				$('body').addClass('overflow');
			},
			close: function () {
				$('body').removeClass('overflow');
			}
		}
	});
	let touchstartX;
	let touchendX;
	// gallery modal
	$('.js-gallery-block').each(function () {
		$(this).magnificPopup({
			type: 'image',
			delegate: '.js-gallery-link',
			mainClass: 'mfp-zoom-in mfp-gallery',
			fixedContentPos: true,
			removalDelay: 160,
			tClose: 'Закрыть',
			image: {
				tError: 'Невозможно загрузить :('
			},
			iframe: {
				tError: 'Невозможно загрузить :('
			},
			gallery: {
				enabled: true,
				tPrev: 'Назад',
				tNext: 'Вперед',
				tCounter: '%curr% / %total%'
			},
			callbacks: {
				open: () => {
					$('body').addClass('overflow');
					/* swipe detection */
					if ($(window).width() <= 1024) {
						$(window).on('touchstart', function (event) {
							touchstartX = event.changedTouches[0].screenX;
						});
						$(window).on('touchend', function (event) {
							touchendX = event.changedTouches[0].screenX;
							handleGesure();
						});
						function handleGesure() {
							if (touchendX < touchstartX && touchstartX - touchendX > 50) {
								$.magnificPopup.instance.next();
							}
							if (touchendX > touchstartX && touchendX - touchstartX > 50) {
								$.magnificPopup.instance.prev();
							}
						}
					}
				},
				close: function () {
					$('body').removeClass('overflow');
				}
			}
		});
	});
	// close modal
	$(document).on('click', '.js-modal-close', function () {
		$.magnificPopup.close();
	});
	/* add scripts */
	// first visit
	// clinic choose
	// $('.visit-form input.js-clinic-change').on('change', function () {
	// 	const itemLink = $(this).parent().find('.item-link');
	// 	var clinicName = itemLink.text(),
	// 		legalClinicName = itemLink.attr('data-legal-name') || itemLink.text(),
	// 		clinicColor = $(this).siblings('.label').attr('style');
	// 	let clinic = $(this).attr('data-clinic');
	// 	$('.legal-clinic[data-clinic="' + clinic + '"]').removeClass('not_show');
	// 	$('.form-tab[data-tab="2"]').find('.clinic-types').append('<span class="type-item" style="' + clinicColor + '">' + clinicName + '</span>');
	// 	$('.form-tab[data-tab="2"]').find('.clinic-name').text(legalClinicName);
	// 	// $('.form-tab[data-tab="1"]').removeClass('active');
	// 	$('.form-tab[data-tab="2"]').addClass('active');

	// 	$('.email_to').attr('disabled', true);
	// 	$('.email_to[data-clinic="' + clinic + '"]').attr('disabled', false);
	// });
	// check add info
	$('.visit-form input.js-add-group').on('change', function () {
		if ($(this).prop('checked')) {
			$(this).parents('.input-group').siblings('.add-group').slideUp(300);
			$(this).parents('.input-group').siblings('.add-group').find('input').prop('disabled', true);
		}
		else {
			$(this).parents('.input-group').siblings('.add-group').slideDown(300);
			$(this).parents('.input-group').siblings('.add-group').find('input').prop('disabled', false);
		}
	});
	// Обработчик для кнопки "Добавить информацию о ребенке"
	$('.visit-form .js-child-link').on('click', function () {
		$(this).parent().siblings('.child-form').find('.child-form__item').first().show();
		$(this).hide();
		$(this).siblings('.child-cancel').show();
		$(this).siblings('p').hide();

		// Обновляем валидацию после добавления блока
		const currentStep = parseInt($('.visit-form .steps-list .step-item.active').attr('data-step'));
		validateStep(currentStep);
	});
	// Обработчик для кнопки "Добавить доверенное лицо"
	$('.visit-form .js-person-link').on('click', function () {
		$(this).parent().siblings('.person-form').find('.person-form__item').first().show();
		$(this).hide();
		$(this).siblings('.person-cancel').show();
		$(this).siblings('p').hide();

		// Обновляем валидацию после добавления блока
		const currentStep = parseInt($('.visit-form .steps-list .step-item.active').attr('data-step'));
		validateStep(currentStep);
	});
	// Обработчик для кнопки "Отменить"
	$('.visit-form .js-cancel-link').on('click', function () {
		$(this).parent().siblings('.person-form').find('.person-form__item').hide();
		$(this).parent().siblings('.child-form').find('.child-form__item').hide();
		$(this).siblings('.js-child-link').show();
		$(this).siblings('.js-person-link').show();
		$(this).siblings('p').show();
		$(this).hide();

		// Обновляем валидацию после удаления блока
		const currentStep = parseInt($('.visit-form .steps-list .step-item.active').attr('data-step'));
		validateStep(currentStep);
	});
	// change steps
	$('.visit-form .js-step-link').click(function () {
		var currentStep = parseInt($('.visit-form .steps-list .step-item.active').attr('data-step')),
			nextStep = parseInt($(this).attr('data-step')),
			allSteps = parseInt($('.visit-form .steps-list .step-item').length);

		// Если переходим вперед - проверяем валидность текущего шага
		if (nextStep > currentStep) {
			if (!validateStep(currentStep)) {
				// Прокручиваем к первому ошибочному полю
				const $firstError = $('.visit-form .steps-list .step-item.active .input-group.error').first();
				if ($firstError.length) {
					$('html, body').animate({
						scrollTop: $firstError.offset().top - 100
					}, 500);
				}
				return false;
			}
		}

		var percentStep = ((nextStep - 1) / (allSteps - 1)) * 100;
		$('.visit-form .steps-list .step-item').removeClass('active');
		$('.visit-form .steps-list .step-item[data-step="' + nextStep + '"]').addClass('active');
		if (nextStep == allSteps) {
			$('.visit-form .step-count').text('Готово');
		}
		else {
			$('.visit-form .step-count span.step').text(nextStep);
		}
		$('.visit-form .step-percent').text(parseInt(percentStep) + '%');
		$('.visit-form .progress-row').css('--value', percentStep + '%');
		$(window).scrollTop($('#visit-form').offset().top - 185);
	});
	// submit form
	$('.visit-form .js-submit-btn').on('click', function (e) {
		e.preventDefault();

		// Проверяем валидность текущего шага перед отправкой
		var currentStep = parseInt($('.visit-form .steps-list .step-item.active').attr('data-step'));
		if (!validateStep(currentStep)) {
			alert('Пожалуйста, заполните все обязательные поля');
			return false;
		}

		const form = document.querySelector('.visit-form');
		const formData = new FormData(form);

		// Отправка данных как FormData
		fetch('/api/forms/first-visit/', {
			method: 'POST',
			body: formData,
			headers: {
				'X-CSRFToken': getCookie('csrftoken') // Если используете Django
			}
		})
			.then(response => {
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				return response.json();
			})
			.then(data => {
				// Успешная отправка - переходим на 5 шаг
				var allSteps = parseInt($('.visit-form .steps-list .step-item').length);
				$('.visit-form .steps-list .step-item').removeClass('active');
				$('.visit-form .steps-list .step-item[data-step="' + allSteps + '"]').addClass('active');
				$('.visit-form .step-count span').text(allSteps);
				$('.visit-form .step-percent').text('100%');
				$('.visit-form .progress-row').css('--value', '100%');
				$(window).scrollTop($('#visit-form').offset().top - 185);
			})
			.catch(error => {
				console.error('Error:', error);
				alert('Произошла ошибка при отправке формы. Пожалуйста, попробуйте еще раз.');
			});
	});
	// end form
	$('.visit-form .js-end-form').on('click', function () {
		location.reload();
	});

	let activated;

	/* fix video */
	$('audio,video').bind('play', function () {
		activated = this;
		$('audio,video').each(function () {
			if (this != activated) this.pause();
		});
	});

	/* fix ya btn wtf */
	let getType = /Android|iPhone|iPad|IEMobile/i.test(window.navigator.userAgent) ? 'Mobile' : 'Desktop';

	// number input
	$(document).on('input', '.js-number-input', function () {
		$(this).val($(this).val().replace(/[^0-9]/g, ''));
	});
	// code input
	$('.js-code-input').click(function () {
		$(this).setCursorPosition(0);
	}).mask("999-999");


	// cookie message
	if (!getCookie('cookieMessage') || getCookie('cookieMessage') == 'undefined') {
		// show
		setTimeout(function () {
			$('#cookieMessage').fadeIn(300);
		}, 1000);
		// agree
		$(document).on('click', '.js-cookie-ok', function () {
			setCookie('cookieMessage', 'true', 365);
			$('#cookieMessage').fadeOut(300);
			$('.js-cookie-ok').slideUp(300);
		});
	}

	/* do not remove :) */
	/*setTimeout(function () {
		console.log('%c Created by BENJi (FRONT)', 'background: #222; font-size:160%;');
		console.log('%c ✉️ bbenjamin@rambler.ru	 📱 https://t.me/benjidevil	💻 https://benjidevil.github.io/', 'background: #222; font-size:160%;');
	}, 5000);*/
});
/* eslint-enable no-unused-vars */